<script>
import {
  orderStatusFilter,
  orderSourceFilter,
  orderPaymentMethodFilter,
} from '@utils/filter-value-to-text'
import formatDate from '@utils/format-date'
import pageMixin from '@src/mixins/pagination'

export default {
  components: {
    PrepaidOrderDetail: () => import('@components/Orders/PrepaidOrderDetail'),
  },
  filters: {
    orderStatusFilter,
    orderSourceFilter,
    orderPaymentMethodFilter,
    formatDate,
  },
  mixins: [pageMixin],
  props:{
    memberInfoId:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      loadedOrders: [],
      tryingToGetOrder: false,
      drawerVisible: false,
      drawerOrderData: '',
      filterData:{
        order_by:'created_at',
        order:'desc'
      },
      componentKey: 0,
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build'
    }
  },
  watch: {
    currentPage: {
      handler: 'tryToSearchOrder',
      immediate: true,
    },
  },
  methods: {
    calcRowClassName({ row }) {
      const orderStatus = row.status
      const orderUsedStatus = row.groupSize / row.usedSize

      if (orderStatus === 0) return 'order--canceled'
      if (orderUsedStatus === 1) return 'order--used'
    },
    async tryToGetOrder(row) {
      this.tryingToGetOrder = true
      this.drawerOrderData = await this.$store.dispatch(
        'prepaid/fetchOrderSingle',
        row.id
      )
      this.tryingToGetOrder = false
      this.drawerVisible = true
    },
    async tryToSearchOrder() {
      const { items, total } = await this.$store.dispatch(
        'prepaid/fetchOrders',
        Object.assign(
          { 
            memberId: this.memberInfoId, 
            paymentMethod: 'All' ,
            order_by:this.filterData.order_by,
            order:this.filterData.order,
          },
          this.pageQuery
        )
      )
      this.loadedOrders = items
      this.$nextTick(() => {
        this.$refs.pagination && this.$refs.pagination.updateTotal(total)
      })
    },
     sortChange({column, prop, order}){
      if(order){
  
        this.filterData.order_by = prop
        this.filterData.order = order==='ascending'?'asc':'desc'
        this.currentPage=1
        this.tryToSearchOrder()
      }
      // console.log(column, prop, order)
    }
  },
}
</script>

<template>
  <div>
    <div class="el-table-wrapper pb-3">
      <el-table
        v-loading.fullscreen.lock="tryingToGetOrder"
        element-loading-text="取得訂單資訊中"
        :data="loadedOrders"
        :default-sort="{ prop: 'date', order: 'descending' }"
        :row-class-name="calcRowClassName"
        class="isStyleBgDark"
        @row-click="tryToGetOrder"
        @sort-change="sortChange"
      >
        <el-table-column v-slot="{ row }" label="服務項目/服務時間"  min-width="160">
          <div>
            <b>{{ row.prepaidTitle }}</b>
            
          </div>
          <div class="Jost">
            <span class="text-secondary fs-sm mr-2">${{ row.total }}</span>
            <span class="text-text-light fs-sm">剩餘：{{ row.times - row.used }} / {{ row.times }}次</span>
          </div>
        </el-table-column>


        <el-table-column v-slot="{ row }" min-width="150" :label="`${$t('reserve.CLIENT')}及備註`">
          <div>
            <!-- FIX: 包月綁寵物，要改成寵物名稱 -->
            {{ row.sizeTitle }}
          </div>
          <div v-if="row.note" class="fs-sm">
            {{ row.note }}
          </div>
        </el-table-column>
      </el-table>
      <BasePagination ref="pagination" :current-page.sync="currentPage" :display-column="true"/>
    </div>
    <el-drawer
      ref="drawer"
      class="only-close"
      :class="{ 'appStyle': appStyle }"
      custom-class="order-drawer"
      append-to-body
      :modal-append-to-body="false"
      :wrapper-closable="false"
      :visible.sync="drawerVisible"
      :size="$root.isSmallDevice ? '100%' : '90%'"
      :destroy-on-close="true"
      @closed="componentKey++"
    >
      <PrepaidOrderDetail 
        ref="orderDetail" 
        :default-value.sync="drawerOrderData"
        order-type="prepaid"  
        @update="tryToSearchOrder" 
      />
    </el-drawer>
  </div>
</template>
